
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinmarol() {



const cardData = {
  keyword: 'Cab Service in Marol MIDC Andheri',
  heading: 'eTravo: Reliable and Professional Corporate Cab Services in Marol MIDC Andheri',
  headingDescription: 'eTravo offers specialized corporate cab services in Marol MIDC Andheri, designed to meet the diverse transportation needs of businesses and employees in this dynamic industrial and commercial hub. Whether you require daily employee commutes, executive transfers, or client pickups, our services ensure punctuality, safety, and comfort. Equipped with GPS tracking, air-conditioned vehicles, and professional drivers, eTravo delivers tailored transport solutions that streamline corporate mobility within Marol MIDC and to key areas in Andheri and Mumbai.',

  top: 'Prominent Industrial and Commercial Locations in Marol MIDC Andheri Served by eTravo',
  topPlaces: [
    {
      title: 'Marol MIDC Industrial Estate',
      description: 'A bustling industrial zone with manufacturing units, warehouses, and service providers. eTravo facilitates smooth, timely transport for employees working across shifts and management personnel.'
    },
    {
      title: 'Marol Naka Metro Station',
      description: 'An important transit hub connecting Marol MIDC to the greater Mumbai area. Our cab services provide seamless last-mile connectivity, ensuring hassle-free daily commutes.'
    },
    {
      title: 'MIDC Andheri East Commercial Complex',
      description: 'A hub for offices and businesses across various sectors. eTravo offers dedicated corporate cab services for staff, clients, and executives visiting this busy commercial area.'
    },
    {
      title: 'Marol Bus Depot',
      description: 'Serving numerous public and private routes, this depot is a critical transport node. Our corporate cab fleet complements public transit by offering direct and comfortable rides.'
    },
    {
      title: 'International Airport Business Parks',
      description: 'Located near the Mumbai international airport, these parks house multinational companies. eTravo supports corporate travel with prompt airport transfers and shuttle services.'
    },
    {
      title: 'MIDC Andheri East IT Park',
      description: 'Home to several IT and tech firms, this area demands reliable transport solutions. Our services ensure smooth commutes and client visits with professional, punctual cabs.'
    },
    {
      title: 'Logistics and Warehousing Centers',
      description: 'Numerous logistics firms operate in Marol MIDC, requiring flexible transport for shift workers. eTravo’s staff pickup and drop cabs efficiently cover these routes.'
    },
    {
      title: 'Marol Industrial Area Headquarters',
      description: 'The administrative center for the industrial area. We provide transport solutions tailored for officials and employees, ensuring timely arrivals for meetings and daily tasks.'
    },
    {
      title: 'Local Business Establishments',
      description: 'Small to medium-sized enterprises form the backbone of Marol MIDC. Our affordable cab rentals and transport solutions help maintain smooth business operations.'
    },
    {
      title: 'Andheri East Railway Station',
      description: 'A major railway station serving the area. eTravo’s corporate cabs provide convenient first and last-mile connectivity for employees and business travelers.'
    }
  ],

  services: [
    {
      name: 'Marol MIDC Corporate Cab Rentals',
      description: 'Flexible and scalable cab rental packages for businesses in Marol MIDC, designed to accommodate varying employee strengths, shift patterns, and corporate events with ease.'
    },
    {
      name: 'Employee Transport Cab Marol MIDC',
      description: 'Reliable daily employee transport solutions with scheduled pickups and drop-offs, equipped with GPS tracking and professional chauffeurs to ensure safety and timeliness.'
    },
    {
      name: 'Business Cab Services Marol MIDC Andheri',
      description: 'Tailored cab services for business travel, including inter-office visits, client meetings, and site inspections, with a fleet ranging from economy cars to executive vehicles.'
    },
    {
      name: 'Corporate Staff Cabs Marol',
      description: 'Comprehensive staff transportation services, featuring multi-stop routes, shift-based scheduling, and real-time tracking to optimize route efficiency and employee satisfaction.'
    },
    {
      name: 'Reliable Corporate Cab Service Marol MIDC Andheri',
      description: 'Our service is recognized for consistent punctuality, clean and well-maintained vehicles, and courteous drivers, ensuring hassle-free corporate travel daily.'
    },
    {
      name: 'AC Corporate Cabs Marol MIDC',
      description: 'Fully air-conditioned and sanitized fleet ensuring comfortable travel, especially important for Mumbai’s climate, with a focus on health and hygiene standards.'
    },
    {
      name: 'Staff Pickup and Drop Cab Marol MIDC',
      description: 'Flexible staff transportation services covering all shifts, holidays, and emergency needs, designed to support seamless operations for companies of all sizes.'
    },
    {
      name: 'Affordable Business Cab Rentals Marol',
      description: 'Cost-effective corporate cab rental plans with transparent pricing, , and monthly billing options to suit diverse business budgets and requirements.'
    },
    {
      name: 'Executive Cab Services Marol MIDC',
      description: 'Premium transportation solutions for executives and VIP clients, offering luxury vehicles, professional chauffeurs, and personalized scheduling to maintain a high corporate standard.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Marol MIDC',
      description: 'All-inclusive monthly rental plans covering employee commutes, client visits, and business events, supported by 24/7 customer support and real-time fleet monitoring.'
    },
    {
      name: 'Industrial Area Employee Transport Marol MIDC',
      description: 'End-to-end transport management for industrial area employees, featuring optimized multi-route planning, compliance with safety regulations, and real-time tracking.'
    },
    {
      name: 'Corporate Client Cabs Marol MIDC',
      description: 'Professional and comfortable client transportation services designed to ensure positive impressions and hassle-free travel experiences for visiting business partners.'
    },
    {
      name: 'Business Meeting Cabs Marol MIDC Andheri',
      description: 'On-demand and scheduled cab services for business meetings, conferences, and urgent site visits, offering flexibility and reliability within Marol MIDC and the Andheri region.'
    },
    {
      name: 'Marol MIDC Industrial Area Cab Hire',
      description: 'Dedicated cab hire services for staff commutes, corporate events, and emergency transport needs, with scalable fleet availability and flexible booking options.'
    },
    {
      name: 'Corporate Shuttle Cabs Marol MIDC',
      description: 'Group shuttle services designed to transport teams efficiently between offices, industrial units, transit points, and residential areas in Marol MIDC.'
    }
  ],

  tableData: [
    ['Marol MIDC Corporate Cab Rentals', 'Employee Transport Cab Marol MIDC'],
    ['Business Cab Services Marol MIDC Andheri', 'Corporate Staff Cabs Marol'],
    ['Reliable Corporate Cab Service Marol MIDC Andheri', 'AC Corporate Cabs Marol MIDC'],
    ['Staff Pickup and Drop Cab Marol MIDC', 'Affordable Business Cab Rentals Marol'],
    ['Executive Cab Services Marol MIDC', 'Monthly Corporate Cab Rentals Marol MIDC'],
    ['Industrial Area Employee Transport Marol MIDC', 'Corporate Client Cabs Marol MIDC'],
    ['Business Meeting Cabs Marol MIDC Andheri', 'Marol MIDC Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Marol MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Tailored Corporate Cab Services for Marol MIDC Andheri",
        "WhyChoosedescription": "eTravo delivers highly customized cab solutions specifically designed for businesses operating within Marol Industrial Area MIDC, Andheri. Recognizing the fast-paced corporate environment of Andheri, we focus on providing timely, reliable, and comfortable transportation for your employees, reducing commute-related stress and ensuring consistent punctuality. Our services help companies enhance workforce productivity by facilitating smooth and efficient daily travel."
    },
    {
        "WhyChooseheading": "Diverse and Modern Fleet to Suit Every Corporate Need",
        "WhyChoosedescription": "Our fleet comprises a wide range of vehicles, including premium sedans, spacious SUVs, and versatile MUVs, enabling businesses to choose rides that best fit their corporate requirements. Whether for daily commutes, client meetings, or transporting teams across the city, we offer options that prioritize comfort, style, and safety."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expert Knowledge of Marol MIDC Andheri",
        "WhyChoosedescription": "Our professional drivers are well-trained and have in-depth familiarity with Marol MIDC and surrounding business corridors in Andheri. Their expertise in navigating traffic and finding the quickest routes ensures that employees reach their destinations promptly, minimizing delays and maximizing efficiency."
    },
    {
        "WhyChooseheading": "Flexible and Convenient Booking Options Tailored for Corporate Clients",
        "WhyChoosedescription": "We offer a variety of booking choices including on-demand rides, scheduled pickups, and long-term corporate contracts, allowing businesses to adapt their transportation plans seamlessly according to shifting project timelines and employee schedules."
    },
    {
        "WhyChooseheading": "Advanced Real-Time Tracking to Ensure Safety and Transparency",
        "WhyChoosedescription": "All our cabs are equipped with GPS tracking technology, providing corporate clients with real-time visibility of their employees’ journeys. This transparency not only enhances safety but also allows for proactive management of travel plans and quick responses to any unforeseen delays."
    },
    {
        "WhyChooseheading": "Transparent Billing with Detailed Invoices for Corporate Accountability",
        "WhyChoosedescription": "We maintain clear and comprehensive billing practices by providing itemized invoices that include trip details, fare breakdowns, and any additional charges. This facilitates smooth expense tracking, budgeting, and reimbursement processes for corporate finance teams."
    },
    {
        "WhyChooseheading": "Commitment to Safety and Hygiene with Rigorous Protocols",
        "WhyChoosedescription": "In adherence to current health and safety guidelines, our vehicles are regularly sanitized, and our drivers follow strict hygiene standards including wearing masks and sanitizing hands. This ensures a clean and secure travel environment for all passengers."
    },
    {
        "WhyChooseheading": "Dedicated Corporate Account Management for Personalized Support",
        "WhyChoosedescription": "Every corporate client is assigned a dedicated account manager who acts as a single point of contact for all transportation needs. This personalized support streamlines bookings, handles queries promptly, and ensures that your company’s specific requirements are consistently met."
    }
]
}
const faqData = [
    [
        {
            question: "Which areas are served by your corporate cab service in Marol MIDC Andheri?",
            answer: "Our service area includes Marol Industrial Area MIDC and adjacent regions such as Andheri East, MIDC, SEEPZ, and neighboring commercial hubs."
        },
        {
            question: "Can we schedule recurring rides for employees in Marol MIDC?",
            answer: "Yes, we offer flexible recurring ride scheduling to ensure employees have reliable transportation aligned with their work shifts."
        },
        {
            question: "Is monthly billing available for corporate clients?",
            answer: "Absolutely. We provide monthly billing with detailed invoices for seamless expense management and easy reconciliation."
        },
        {
            question: "Are your drivers trained in professional corporate etiquette?",
            answer: "Yes, our drivers undergo extensive training to maintain professionalism, courtesy, and adhere to corporate conduct standards."
        },
        {
            question: "How do you ensure passenger safety and hygiene during rides?",
            answer: "We implement real-time GPS tracking, regular vehicle maintenance, and strict hygiene protocols including sanitization and use of protective gear to ensure passenger safety."
        },
        {
            question: "Do you provide dedicated support for corporate clients in Marol MIDC?",
            answer: "Yes, corporate clients have access to a dedicated account manager and a support line for quick assistance and personalized service."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Rohan Kulkarni",
        designation: "Operations Manager, TechSphere Solutions",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s corporate cab service in Marol MIDC Andheri has transformed our employee transportation with reliable rides and excellent customer support.”"
    },
    {
        name: "Ms. Sneha Patil",
        designation: "HR Lead, UrbanEdge Technologies",
        rating: [1, 1, 1, 1, 1],
        text: "“The professionalism and flexibility offered by eTravo make them our preferred cab partner for corporate travel in Andheri.”"
    }
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Marol MIDC Andheri",
  "image": "https://www.etravo.in/images/keyword/cab-service-marol-midc-andheri.jpg",
  "description": "Hire reliable cab services in Marol MIDC Andheri for corporate staff transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7742"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-marol-midc-andheri"
  }
};







    return (
        <div>

<Helmet>
  <title>Cab Service in Marol MIDC Andheri | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Marol MIDC Andheri for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinmarol;